var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pega-print-page-break",
      class: { "hide-for-print": _vm.messages.length === 0 },
      attrs: { "data-test": "outer-div" },
    },
    [
      _c(
        "div",
        { staticClass: "boss-layout-block-large hide-for-print" },
        [
          _c("accordion", {
            attrs: {
              "is-open": true,
              "head-class": "pega-accordion-head-important",
            },
            scopedSlots: _vm._u([
              {
                key: "head",
                fn: function () {
                  return [_vm._v("\n        メッセージ作成\n      ")]
                },
                proxy: true,
              },
              {
                key: "body",
                fn: function () {
                  return [
                    _c("job-pre-published-preview-message-form", {
                      on: { fetchMessages: _vm.fetchMessages },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "boss-layout-block-large" },
        [
          _vm.messages.length
            ? _c("accordion", {
                attrs: {
                  "is-open": true,
                  "head-class": "pega-accordion-head-important",
                  "data-test": "message-history",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "head",
                      fn: function () {
                        return [_vm._v("\n        メッセージ履歴\n      ")]
                      },
                      proxy: true,
                    },
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c("job-pre-published-preview-message-history", {
                            attrs: { messages: _vm.messages },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2279345906
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }